import React, { FormEvent, useState } from "react";

interface SubTaskFormProps {
  onSubmit: (title: string) => Promise<void>;
  onCancel: () => void;
  initialTitle?: string;
  submitText?: string;
}

export const SubTaskForm: React.FC<SubTaskFormProps> = ({
  onSubmit,
  onCancel,
  initialTitle = "",
  submitText = "Add Subtask",
}) => {
  const [title, setTitle] = useState(initialTitle);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!title.trim()) return;

    setIsSubmitting(true);
    try {
      await onSubmit(title);
      if (!initialTitle) setTitle("");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="space-y-4">
        <div>
          <label
            className="block text-sm font-medium mb-1"
            htmlFor="subtask-title"
          >
            Subtask Title
          </label>
          <input
            id="subtask-title"
            className="form-input w-full"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter subtask title"
            disabled={isSubmitting}
          />
        </div>
        <div className="flex justify-end space-x-2">
          <button
            type="button"
            className="btn-sm border-gray-200 hover:border-gray-300 text-gray-600"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn-sm bg-indigo-500 hover:bg-indigo-600 text-white"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : submitText}
          </button>
        </div>
      </div>
    </form>
  );
};
